import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { DownOutlined, InfoCircleFilled, RightOutlined, WarningFilled } from '@ant-design/icons'
import type React from 'react'
import { useState } from 'react'
import { Tooltip } from 'antd'

type ErrorListProps = {
  errors: Record<string, { terminal: string; card: string }[]>
  tooltip: React.ReactNode
}

export const ErrorList: React.FC<ErrorListProps> = ({ errors, tooltip }) => {
  const [isExpanded, setIsExpanded] = useState([])
  const errorTitles = Object.keys(errors).map((t) =>
    t === 'Automatic Activity.loading card already exists' ? 'Existing Automatic - Activity Based Cards' : t
  )
  const errored = Object.values(errors)
  return (
    <>
      {errorTitles.map((errorTitle, index) => (
        <>
          <Horizontal className={'full-height-width border-bottom'} verticalCenter>
            <Vertical flex={0.1} verticalCenter>
              <GraviButton
                className='ghost-gravi-button ml-2'
                icon={isExpanded.includes(index) ? <DownOutlined /> : <RightOutlined />}
                onClick={() => {
                  isExpanded.includes(index)
                    ? setIsExpanded(isExpanded.filter((i) => i !== index))
                    : setIsExpanded([...isExpanded, index])
                }}
              />
            </Vertical>
            <Horizontal flex={1} verticalCenter>
              <Texto category={'h4'} className={'py-2'}>
                <WarningFilled style={{ color: 'var(--theme-warning)' }} className={'mr-2'} />
                {errorTitle}
              </Texto>

              <Tooltip title={<Vertical>{tooltip}</Vertical>}>
                <InfoCircleFilled className={'mx-2'} />
              </Tooltip>
              <Texto category={'h4'}>({errored[index]?.length})</Texto>
            </Horizontal>
          </Horizontal>

          {isExpanded.includes(index) && (
            <>
              <Horizontal
                className={'full-height-width bg-2 px-3 border-bottom'}
                justifyContent={'space-between'}
                verticalCenter
                flex={1}
              >
                <Horizontal flex={1} justifyContent={'space-between'} verticalCenter className={'py-2'}>
                  <Texto category={'h6'} appearance={'medium'}>
                    TERMINAL
                  </Texto>
                  <Texto category={'h6'} appearance={'medium'} className={'mr-2'}>
                    |
                  </Texto>
                </Horizontal>

                <Vertical flex={1} verticalCenter>
                  <Texto category={'h6'} appearance={'medium'}>
                    CARD NAME
                  </Texto>
                </Vertical>
              </Horizontal>
              <Vertical verticalCenter className={'full-height-width'}>
                {errored[index]?.map((error) => {
                  return (
                    <Horizontal
                      style={{ minHeight: '30px', maxHeight: '30px' }}
                      className={'bordered bg-error-dim py-2 px-3'}
                      verticalCenter
                      flex={1}
                    >
                      <Vertical flex={1}>
                        <Texto category={'h6'}>{error.terminal}</Texto>
                      </Vertical>
                      <Vertical flex={1}>
                        <Texto category={'h6'}> {error.card}</Texto>
                      </Vertical>
                    </Horizontal>
                  )
                })}
              </Vertical>
            </>
          )}
        </>
      ))}
    </>
  )
}
